
<section class="row w-185">
  <div>
      <div class="flex w-full justify-start font-body">
        <a 
            class="text-primary-400 text-xs cursor-pointer flex"
            (click)="goToLogin()">
           <div class="chevron-left-blue mr-0.5x"></div> Back to Login
        </a>
    </div>
      <div class="flex flex-col mb-8">
        <div class="two-factor-login mx-auto mb-2"></div>
        <div class="flex flex-col items-center">
          <div class="text-secondary-500 text-xs font-body-semibold mb-0.5x">For your security, we’re verifying it’s you.</div>
          <div class="text-xs text-title-default">{{otpSendTypeText[otpSendType]}}</div>
        </div>
      </div>
          <div class="animate-opacity form-container w-185 flex flex-col">
            <app-otp-input [otpSessionId]="otpSession" [challenge]="loginChallenge"></app-otp-input>
          </div>
  </div>
</section>
